var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassLocationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 293.31 74.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: .07em;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-4, .cls-3 {\n        font-family: Serifa-Med, Serifa;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #ffa706;\n        font-size: 50px;\n      }\n\n      .cls-5 {\n        fill: #00c605;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        fill: #ee7d33;\n      }\n\n      .cls-4 {\n        fill: #878787;\n        font-size: 22.17px;\n      }\n\n      .cls-9 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-10 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-11 {\n        letter-spacing: 0em;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(53.41 41.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(86.26 41.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(121.91 41.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(169.86 41.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(195.96 41.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(234.06 41.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(263.06 41.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.54,55.23c-4.86,1.73-9.73,3.44-14.59,5.19l2.33,2.16c.38-.12.78-.18,1.18-.17,1.9-.06,3.5,1.42,3.58,3.32,0,.36-.06.72-.19,1.06l2.35,2.16c1.85-4.4,3.69-8.8,5.52-13.2.07-.17.12-.35.23-.62l-.4.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.71,22.01c-.47-.71-1.82-.91-2.82-1.17-1.26-.18-2.25-1.15-2.47-2.4-.27-.75-.59-1.48-.95-2.19-.14-.39-.14-.83,0-1.22.49-1.19,1.12-2.32,1.62-3.51.09-.34.02-.71-.19-1-.86-1-1.83-1.82-2.7-2.76-.29-.4-.85-.49-1.26-.2,0,0,0,0-.01,0-1,.55-2.15,1-3.2,1.56-.48.29-1.07.29-1.55,0-1-.5-2.07-.83-3.07-1.32-.41-.2-.74-.53-.94-.94-.48-1.11-.88-2.27-1.25-3.43-.1-.49-.56-.82-1.06-.74h-3.77c-.42.06-.79.3-1,.67-.49,1.15-.85,2.36-1.31,3.52-.14.34-.38.62-.69.8-1.33.61-2.7,1.61-4,1.58s-2.66-1.09-4-1.7l-.08-.06c-.33-.29-.83-.25-1.11.08-.02.03-.05.06-.07.09-.9.93-1.82,1.76-2.72,2.76-.24.32-.31.74-.2,1.12.49,1.19,1.12,2.32,1.63,3.51.12.37.12.76,0,1.13-.43,1.1-.89,2.24-1.4,3.24-.18.38-.48.7-.86.89-1.12.47-2.28.88-3.44,1.25-.54.09-.91.59-.83,1.13C.01,23.92.06,25.14.01,26.36c-.05.52.31.99.83,1.08,1.13.36,2.26.75,3.34,1.21.43.19.78.52,1,.93.5,1.03.95,2.09,1.33,3.17.15.43.15.89,0,1.32-.5,1.18-1.13,2.27-1.6,3.43-.11.39-.04.8.2,1.13.83.93,1.79,1.76,2.63,2.68.33.42.93.5,1.36.2,1.08-.57,2.2-1.07,3.3-1.59l.63-.27c.83.48,1.71.86,2.62,1.15,1.42.27,2.52,1.41,2.73,2.84.25.92.47,2.13,1.14,2.59s1.88.16,2.86.17c2.24,0,2.34,0,3-2.14.38-1.75,1.67-3.16,3.38-3.7,1.47-.73,3.2-.66,4.61.17,2.22,1.25,2.29,1.13,4.09-.66,2-1.94,2.05-2,.74-4.41-.74-1.33-.79-2.93-.13-4.3.55-1.82,2.07-3.18,3.94-3.54,2-.54,2-.65,2-2.67-.09-1.07.21-2.39-.3-3.14ZM21.93,38.01c-7.67-.06-13.89-6.24-14-13.91,0-7.73,6.27-14,14.01-13.99,7.73,0,13.99,6.27,13.99,13.99-.09,7.68-6.32,13.87-14,13.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.16,16.74c-3.63,1.29-7.26,2.57-10.89,3.87l1.74,1.61c.28-.09.58-.13.88-.13,1.42-.05,2.61,1.06,2.67,2.48,0,.27-.05.54-.14.79l1.75,1.61c1.38-3.28,2.75-6.56,4.12-9.85.05-.13.09-.26.17-.46l-.3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.64,26.94c-.25.06-.5.1-.76.1-1.42.05-2.61-1.04-2.69-2.46,0-.24.04-.49.11-.72l-1.75-1.61c-1.24,2.95-2.48,5.91-3.71,8.86l-.57,1.38.31-.09,10.82-3.85-1.76-1.61Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(188.48 68.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 16.36,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 31.49,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 46.83,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 61.97,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 78.96,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 87.54,
    y: 0
  }, "T")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassLocationLogo);
export default __webpack_public_path__ + "static/media/compass_locationLogo.887bcec7bb41ae0752172df56327344f.svg";
export { ForwardRef as ReactComponent };